import React from 'react'
import { Link } from 'react-router-dom'
import { Icon, Badge, Tooltip } from 'antd'
import { BadgeProps } from 'antd/lib/badge'
import { TooltipProps } from 'antd/lib/tooltip'
import styles from './index.scss'

export interface MessageNotificationProps {
  count: number
  style?: React.CSSProperties
}

const MessageNotification = ({ count, style }: MessageNotificationProps) => {
  const tooltipProps: TooltipProps = {
    placement: 'bottom',
    title: `${count}个问题待回复`,
    overlayClassName: 'message-notification',
  }
  const badgeProps: BadgeProps = {
    count: count,
    offset: [-3, 5],
  }

  const content = (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      <Badge {...badgeProps}>
        <Icon type="mail" className={styles.icon} />
      </Badge>
    </span>
  )

  return (
    <Link to="/usercenter/message">
      <div className={styles.notification} style={style}>
        {count ? <Tooltip {...tooltipProps}>{content}</Tooltip> : content}
      </div>
    </Link>
  )
}

export default MessageNotification
